(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShiftOccupationDetailController', ShiftOccupationDetailController);

    ShiftOccupationDetailController.$inject = ['$scope', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'Shokushu', 'User', 'Group', 'ShiftOccupation','pagingParams','paginationConstants','ParseLinks'];

    function ShiftOccupationDetailController ($scope, $state, AlertService, $timeout,$stateParams,$rootScope, Shokushu, User, Group, ShiftOccupation,pagingParams,paginationConstants,ParseLinks) {
        var vm = this;

        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.parentGroup = [];
        vm.resultList = [];
        vm.shiftOccupationList= [];
        vm.state = 1;
        vm.houjinFlag = false;
        vm.selectGroupFlag = false;
        vm.groupAllList = [];
        vm.codeSaveFlag = false;
        vm.nameSaveFlag = false;
        vm.parentFlag = false;

        vm.goEdit = goEdit;
        vm.goAdd = goAdd;
        vm.goCancel = goCancel;
        vm.codeUniqueCheck = codeUniqueCheck;
        vm.nameUniqueCheck = nameUniqueCheck;

        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换
        vm.changeGroup = changeGroup;
        vm.save = save;
        vm.loadShiftOccupation = loadShiftOccupation;
        vm.goDel = goDel;
        vm.changeState = changeState;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.loadShiftOccupation();
            });
        }

        function loadShiftOccupation () {
            //如果父groupId = 0,则可以编辑，否则不可以编辑
            vm.parentGroup.forEach(function (item) {
                if(vm.groupId == item.id){
                    if(item.parentId == ''){
                        vm.parentFlag = true;
                    }else {
                        vm.parentFlag = false;
                    }
                }
            });
            //如果group为parentId==0的group则直接查询
            if(vm.parentFlag) {
                ShiftOccupation.getAll({"groupId":vm.groupId, "state":vm.state}, function(result, headers){
                    vm.resultList = result;
                    vm.shiftOccupationList = angular.copy(result);
                    if(vm.resultList.length==0){
                        var shift = {};
                        shift.id = null;
                        shift.code = "";
                        shift.name = "";
                        shift.state = 1;
                        shift.showFlag = false;
                        vm.resultList.push(shift);
                    }
                });
            //否则查父group的
            }else {
                Group.queryParentGroupId({"groupId":vm.groupId}, function (group) {
                    //当前用户的父groupId
                    var groupId = "gid" + group.groupId;
                    ShiftOccupation.getAll({"groupId":groupId, "state":vm.state}, function(result, headers){
                        vm.resultList = result;
                    });
                });
            }
            /*Group.groupList({"depth": 0}, function(groupList){
                vm.groupAllList = groupList;
                for(var i=0; i<groupList.length; i++){
                    if(!vm.houjinFlag){
                        for(var x=0; x<groupList[i].flags.length; x++){
                            if(groupList[i].flags[x].id == 2){
                                vm.houjinFlag = true;
                                break;
                            }
                        }
                    }
                }
                //如果是法人，直接根据groupId查询
                if(vm.houjinFlag){
                    ShiftOccupation.getAll({"groupId":vm.group.id, "state":vm.state}, function(result, headers){
                        vm.resultList = result;
                        vm.shiftOccupationList = angular.copy(result);
                        if(vm.resultList.length==0){
                            var shift = {};
                            shift.id = null;
                            shift.code = "";
                            shift.name = "";
                            shift.state = 1;
                            shift.showFlag = false;
                            vm.resultList.push(shift);
                        }
                    });
                 //普通用户则查找他父节点的所有的数据
                }else {
                    Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                        //当前用户的父groupId
                        var groupId = "gid" + group.groupId;
                        ShiftOccupation.getAll({"groupId":groupId, "state":vm.state}, function(result, headers){
                            vm.resultList = result;
                            vm.shiftOccupationList = angular.copy(result);
                            if(vm.resultList.length==0){
                                var shift = {};
                                shift.id = null;
                                shift.code = "";
                                shift.name = "";
                                shift.state = 1;
                                shift.showFlag = false;
                                vm.resultList.push(shift);
                            }
                        });
                    });
                }
            });*/
        }

        function goEdit(shiftOccupation){
            shiftOccupation.showFlag = false;
        }

        function goCancel(shiftOccupation, index){
            vm.shiftOccupationList.forEach(function (shift){
                if(shift.id == shiftOccupation.id){
                    shiftOccupation.showFlag = true;
                    shiftOccupation.code = shift.code;
                    shiftOccupation.name = shift.name;
                    shiftOccupation.state = shift.state;
                    codeUniqueCheck (shiftOccupation, index);
                    nameUniqueCheck (shiftOccupation, index);
                }
            });
        }

        function goAdd(index) {
            var shift = {};
            shift.id = null;
            shift.code = "";
            shift.name = "";
            shift.state = 1;
            shift.showFlag = false;
            vm.resultList.splice(index+1,0,shift);
        }

        function goDel(index) {
            if(vm.resultList[index].id == null){
                vm.resultList.splice(index, 1);
            }else{
                ShiftOccupation.delete({id:vm.resultList[index].id}, onSaveSuccess, onSaveError);
            }
        }

        function changeGroup() {
            vm.loadShiftOccupation();
        }

        function save(){
            if(confirm("一括保存してもよろしいでしょうか")){
                ShiftOccupation.save({groupId:vm.group.id,shiftList:vm.resultList}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            loadShiftOccupation();
        }

        function onSaveError (result) {
            vm.resultList = result.data.shiftList;
        }

        function changeState() {
            loadShiftOccupation();
        }

        function codeUniqueCheck (shiftOccupation, index) {
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].code == shiftOccupation.code && index != i){
                    shiftOccupation.codeSingleFlag = true;
                    vm.codeSaveFlag = true;
                    break;
                }else {
                    shiftOccupation.codeSingleFlag = false;
                    vm.codeSaveFlag = false;
                }
            }
        }

        function nameUniqueCheck (shiftOccupation, index) {
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].name == shiftOccupation.name && index != i){
                    shiftOccupation.nameSingleFlag = true;
                    vm.nameSaveFlag = true;
                    break;
                }else {
                    shiftOccupation.nameSingleFlag = false;
                    vm.nameSaveFlag = false;
                }
            }
        }
    }
})();
